export interface PageOptions {
  page?: number;
  itemsPerPage?: number;
  sortBy?: string[];
  sortDesc?: boolean[];
}

export interface ServerPageOptions {
  offset: number;
  limit: number;
  order: string;
}

export type Dictionary<T> = { [key: string]: T };

/**
 * @param prefixDictionary Opcional - Usado para identificar o alias da tabela prefixDictionary["nome"] = "consultor.nome"
 * @returns Opções de paginação formatados para o servidor
 */
export function getServerOptions(
  options: PageOptions,
  prefixDictionary?: Dictionary<string>
): ServerPageOptions {
  const filtro: ServerPageOptions = {
    offset: ((options.page || 1) - 1) * (options.itemsPerPage || 50),
    limit: options.itemsPerPage || 50,
    order: "",
  };

  if (options.sortBy) {
    const mappers = prefixDictionary ?? {};
    const orders = options.sortBy.map(
      (field, i) =>
        `${mappers[field] ?? field} ${
          options.sortDesc && options.sortDesc[i] ? "desc" : "asc"
        }`
    );

    filtro.order = orders.join(", ");
  }

  return filtro;
}
